function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "id2"
}, /*#__PURE__*/React.createElement("path", {
  d: "m349.59 527h188.8v182.15h-188.8z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "id3"
}, /*#__PURE__*/React.createElement("path", {
  d: "m439 282.1h10v20.902h-10z"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m149.96 176c0 32.137-24.984 58.238-55.801 58.238-30.824 0-55.801-26.102-55.801-58.238 0-32.145 24.977-58.195 55.801-58.195 30.817 0 55.801 26.051 55.801 58.195zm0 0",
  fill: "none",
  stroke: "#15122a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 8.3708
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m184.23 422.86v-112.39c0-33.457-23.363-60.57-52.188-60.57h-75.781c-28.82 0-52.188 27.113-52.188 60.57v112.39h180.16",
  fill: "#00a499"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-349.77 -282.12)",
  clipPath: "url(#id2)"
}, /*#__PURE__*/React.createElement("path", {
  transform: "matrix(.13956 0 0 -.13947 147.22 801.75)",
  d: "m2771.4 693.91v805.85c0 239.89-167.41 434.3-373.95 434.3h-543.01c-206.51 0-373.95-194.41-373.95-434.3v-805.85zm0 0",
  fill: "none",
  stroke: "#15122a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 60
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m50.543 252.53 42.91 71.324 44.039-72.008zm0 0",
  fill: "#fff",
  stroke: "#15122a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 8.3708
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#15122a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 8.3708
}, /*#__PURE__*/React.createElement("path", {
  d: "m93.454 324.63v96.809"
}), /*#__PURE__*/React.createElement("path", {
  d: "m105.61 268.14-13.106 13.453-13.102-13.453 13.102-13.449z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m87.399 277.07-12.477 16.313"
}), /*#__PURE__*/React.createElement("path", {
  d: "m98.368 277.85 13.043 17.281"
}), /*#__PURE__*/React.createElement("path", {
  d: "m119.81 54.665c0-14.094-11.43-25.523-25.539-25.523-14.102 0-25.539 11.43-25.539 25.523 0 9.4688 5.1602 17.727 12.82 22.137v7.7578h25.441v-7.7578c7.6602-4.4102 12.816-12.668 12.816-22.137z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m106.99 98.809h-25.441v-14.313h25.441z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m90.872 84.297-6.6719-25.945"
}), /*#__PURE__*/React.createElement("path", {
  d: "m97.829 84.149 6.6719-25.941"
}), /*#__PURE__*/React.createElement("path", {
  d: "m57.172 52.618h-11.617"
}), /*#__PURE__*/React.createElement("path", {
  d: "m142.77 52.907h-11.621"
}), /*#__PURE__*/React.createElement("path", {
  d: "m137.02 29.836-10.234 5.5117"
}), /*#__PURE__*/React.createElement("path", {
  d: "m117.26 10.02-5.4883 10.234"
}), /*#__PURE__*/React.createElement("path", {
  d: "m49.485 28.778 10.227 5.5078"
}), /*#__PURE__*/React.createElement("path", {
  d: "m69.235 8.9575 5.4961 10.234"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-349.77 -282.12)",
  clipPath: "url(#id3)"
}, /*#__PURE__*/React.createElement("path", {
  transform: "matrix(.13956 0 0 -.13947 147.22 801.75)",
  d: "m2128.1 3695.9-0.2799-83.268",
  fill: "none",
  stroke: "#15122a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 60
}));

function SvgIntroFormIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251.18,
    height: 568.95,
    viewBox: "0 0 188.48 427.03",
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroFormIcon3);
export default __webpack_public_path__ + "static/media/introFormIcon3.75e2b29c.svg";
export { ForwardRef as ReactComponent };